module.exports = __webpack_public_path__ + "img/collection-weddingRingsSoleil.691647d.webp";